import React, { useState, useEffect } from 'react';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import MarcasData from '../../Components/Admin/MarcasData/MarcasData';
import SinPermisos from '../../Components/SinPermisos/SinPermisos';
import { fetchUsuario, getUsuario } from '../../Components/user';

export default function Marcas() {
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        fetchUsuario().then(() => setLoading(false));
    }, []);
    const usuario = getUsuario();
    return (
        <div className='containerGrid'>
            <Header />
            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    {loading ? <></> : usuario?.rol === 'admin' ? <MarcasData /> : <SinPermisos />}
                </div>
            </section>
        </div>
    );
}
